import React, { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { FieldSkipReason } from 'src/services/api/api-client';
import { LocalizedResourceDictionaryKeys } from 'src/application/localisation/i18next';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';
import { useGetFieldChanges } from './useGetFieldChangesHistory';
import { FormHistoryContext } from '../provider/historyTab.context';

export const useGetDiffValues = (dataKey: string) => {
  const { t } = useScopedTranslation('Forms.Controls.SkipQuestionReason');
  const { selectedVersion, previousVersionOfSelectedVersion } = useContextSelector(FormHistoryContext, (x) => x);

  const { valueChanges, skipFieldChanges } = useGetFieldChanges();

  const oldSkipReason = useMemo(
    () =>
      previousVersionOfSelectedVersion?.fieldSkipReasons?.[dataKey] !== undefined
        ? t(
            `${
              FieldSkipReason[previousVersionOfSelectedVersion.fieldSkipReasons[dataKey]]
            }` as LocalizedResourceDictionaryKeys,
          )
        : undefined,
    [selectedVersion],
  );

  const newSkipReason = useMemo(
    () =>
      skipFieldChanges?.[dataKey] !== undefined
        ? t(`${FieldSkipReason[skipFieldChanges[dataKey]]}` as LocalizedResourceDictionaryKeys)
        : undefined,
    [selectedVersion],
  );

  return {
    oldValue: previousVersionOfSelectedVersion?.value?.[dataKey],
    changes: valueChanges?.[dataKey],
    newValue: selectedVersion?.value?.[dataKey],
    oldSkipReason,
    newSkipReason,
  };
};
